export const geostruktura = {
  "geotree": {
    "Country": {
      "name": "Chiny",
      "locID": "CNL000001",
      "url": "/chinska-republika-ludowa.xml",
      "Region": [
        {
          "name": "Chiny: wycieczki objazdowe",
          "locID": "CNL100000",
          "url": "/chiny-wycieczki-objazdowe.xml"
        },
        {
          "name": "Chiny Płn.",
          "locID": "CNL000002",
          "url": "/chiny-polnocne.xml",
          "Miniregion": [
            {
              "name": "Mandżuria",
              "locID": "CNL000003",
              "url": "/mandzuria.xml"
            },
            {
              "name": "Mongolia Wewn.",
              "locID": "CNL000010",
              "url": "/mongolia-wewnetrzna.xml"
            },
            {
              "name": "Sinkiang-Ujgur",
              "locID": "CNL000088",
              "url": "/region-sinkiang-ujgur.xml",
              "Areatown": [{
                "name": "Pustynia Takla Makan",
                "locID": "CNL000091",
                "url": "/pustynia-takla-makan.xml"
              }]
            }
          ]
        },
        {
          "name": "Chiny Wsch.",
          "locID": "CNL000013",
          "url": "/chiny-wschodnie.xml",
          "Miniregion": [
            {
              "name": "Okolice Pekinu",
              "locID": "CNL000014",
              "url": "/region-pekinu.xml",
              "Areatown": [
                {
                  "name": "Beijing (Pekin)",
                  "locID": "CNL000015",
                  "url": "/beijing-pekin.xml"
                },
                {
                  "name": "Badaling - Mur Chiński",
                  "locID": "CNL000022",
                  "url": "/badaling-mur-chinski.xml"
                }
              ]
            },
            {
              "name": "Okolice Szanghaju",
              "locID": "CNL000025",
              "url": "/region-szanghaju.xml",
              "Areatown": [{
                "name": "Szanghaj",
                "locID": "CNL000026",
                "url": "/szanghaj.xml"
              }]
            }
          ]
        },
        {
          "name": "Chiny Płd.",
          "locID": "CNL000029",
          "url": "/chiny-poludniowe.xml",
          "Miniregion": [
            {
              "name": "Wybrzeże Płd.",
              "locID": "CNL000030",
              "url": "/wybrzeze-poludniowe.xml",
              "Areatown": [
                {
                  "name": "Hong Kong (metropolia)",
                  "locID": "CNL000032",
                  "url": "/hong-kong-metropolia.xml"
                },
                {
                  "name": "Makau",
                  "locID": "CNL000036",
                  "url": "/makau.xml"
                },
                {
                  "name": "Kanton",
                  "locID": "CNL000037",
                  "url": "/kanton.xml"
                }
              ]
            },
            {
              "name": "Wyspa Hajnan",
              "locID": "CNL000038",
              "url": "/wyspa-hajnan.xml"
            },
            {
              "name": "Góry Południowochińskie",
              "locID": "CNL000040",
              "url": "/gory-poludniowochinskie.xml",
              "Areatown": [{
                "name": "Xiamen",
                "locID": "CNL000046",
                "url": "/xiamen.xml"
              }]
            }
          ]
        },
        {
          "name": "Chiny Centralne",
          "locID": "CNL000050",
          "url": "/chiny-centralne.xml",
          "Miniregion": [
            {
              "name": "Prowincje Centr.-Zachodnie",
              "locID": "CNL000051",
              "url": "/prowincje-centr-zachodnie.xml",
              "Areatown": [{
                "name": "Wielki Budda z Leshan",
                "locID": "CNL000065",
                "url": "/wielki-budda-z-leshan.xml"
              }]
            },
            {
              "name": "Prowincje Centr.-Wsch.",
              "locID": "CNL000066",
              "url": "/prowincje-centr.-wschodnie.xml",
              "Areatown": [
                {
                  "name": "Klasztor Shaolin (Mt. Song)",
                  "locID": "CNL000069",
                  "url": "/klasztor-shaolin-mt.-song.xml"
                },
                {
                  "name": "Jaskinie 10,000 Buddów",
                  "locID": "CNL000071",
                  "url": "/jaskinie-10,000-buddow.xml"
                },
                {
                  "name": "Xi'an",
                  "locID": "CNL000077",
                  "url": "/xian.xml"
                }
              ]
            }
          ]
        },
        {
          "name": "Tybet",
          "locID": "CNL000081",
          "url": "/tybet.xml",
          "Miniregion": [{
            "name": "Tybetański Region Autonomiczny",
            "locID": "CNL000082",
            "url": "/tybetanski-region-autonomiczny.xml",
            "Areatown": [{
              "name": "Lhasa",
              "locID": "CNL000083",
              "url": "/lhasa.xml"
            }]
          }]
        },
        {
          "name": "Wyspa Tajwan",
          "locID": "CNL000092",
          "url": "/wyspa-tajwan.xml",
          "Miniregion": [{
            "name": "Rep. Chińska",
            "locID": "CNL000093",
            "url": "/republika-chinska.xml",
            "Areatown": [{
              "name": "Tajpej",
              "locID": "CNL000094",
              "url": "/tajpej.xml"
            }]
          }]
        }
      ]
    }
  }
}
